import type { ReactNode } from 'react';
import { AppBreadcrumb } from '@/components/AppBreadcrumb/AppBreadcrumb';
import styles from './PageHeader.module.scss';

interface PageHeaderProps {
  actions?: ReactNode;
}

export function PageHeader({ actions }: PageHeaderProps) {
  return (
    <div className={styles.pageHeader}>
      <div className={styles.breadcrumbWrap}>
        <AppBreadcrumb />
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
